
import { Vue, Component, Ref } from 'vue-property-decorator';
import AddInvoiceModal from './AddInvoiceModal.vue';
import InvoiceService from '@/services/invoice.service';
import lazyInject from '@/di';

@Component({
  components: {
    AddInvoiceModal,
  },
})
export default class InvoiceDrawer extends Vue {
  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  @Ref() addInvoiceModal!: AddInvoiceModal;

  visible = false;

  invoiceList: any[] = [];

  kaId = '';

  kaName = '';

  async open(row: any) {
    this.kaId = row.id;
    this.kaName = row.name;
    const res = await this.invoiceService.getInvoiceBuyerList({
      ka_id: row.id,
    });
    this.invoiceList = res;
    this.visible = true;

    // console.log(res);
  }

  onClose() {
    this.visible = false;
  }

  onAddInvoice() {
    this.addInvoiceModal.init({}, 'add');
  }

  async onEditInvoice(item: any) {
    const res = await this.invoiceService.getInvoiceBuyerInfo(item.id);
    // console.log(res, ' res');
    this.addInvoiceModal.init(res, 'edit');
  }

  refresh() {
    this.getInvoiceList();
  }

  async getInvoiceList() {
    const res = await this.invoiceService.getInvoiceBuyerList({
      ka_id: this.kaId,
    });
    this.invoiceList = res;
  }
}
